import vars from './_vars';

const $ = jQuery.noConflict();
// Helper functions:
import { throttle } from './functions/throttle';

// Plugins (NPM modules and uploaded files):
import Swiper, {
	Navigation,
	Pagination,
	Autoplay,
	Thumbs,
} from 'swiper/bundle'; // import Swiper bundle with all modules installed
// available Swiper.js modules = [Virtual, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar, Parallax, Zoom, Lazy, Controller, A11y, History, HashNavigation, Autoplay, Thumbs, FreeMode, Grid, Manipulation, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards]
// import './vendors/jquery.nice-select.min.js'; // jQuery Nice Select
import { Fancybox } from '@fancyapps/ui'; // Fancybox

jQuery(document).ready(function ($) {
	'use strict';

	heroSlider();
	serviceModule();
	sliderModule();
	overviewModule();

	/**
	 * Tweak for mobiles (full height)
	 */
	const fixFullheight = () => {
		const vh = window.innerHeight * 0.01;
		vars.htmlEl.style.setProperty('--vh', `${vh}px`);
	};

	fixFullheight();
	const fixHeight = throttle(fixFullheight);
	window.addEventListener('resize', fixHeight);

	/**
	 * Force load of all lazy-loading images
	 */
	setTimeout(function () {
		$('.lazyload.loading').removeClass('loading').addClass('loaded');
	}, 3000);

	/**
	 * Nice select
	 */
	// do not activate NiceSelect on those pages, where it might conflict with Select2
	// if (!$('body').hasClass('woocommerce-account')) {
	// 	$('select').niceSelect();
	// }

	/**
	 * Trigger NiceSelect update after Woocommerce Update variations
	 */
	$('.variations_form').on('woocommerce_variation_has_changed', function () {
		$('.variations_form select').niceSelect('update');
	});

	// JS Lazyload fix for images on the first screen.
	// This code should run after all the code is initiated.
	$(window).trigger('scroll');

	/**
	 * Aos Animation
	 */
	AOS.init();
});

function heroSlider() {
	if ($(".m-hero__slider .swiper-slide").length == 1) {
		$('.m-hero__slider .swiper-wrapper').addClass("disabled");
		$('.m-hero__slider .swiper-pagination').addClass("disabled");
	}
	if ($('.m-hero__slider').length && $(".m-hero__slider .swiper-slide").length > 1) {
		new Swiper('.m-hero__slider', {
			slidesPerView: 1,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			loop: true,
			spaceBetween: 24,
			direction: 'horizontal',
			pagination: {
				el: '.swiper-pagination',
				// dynamicBullets: true,
				clickable: true,
			},
		});
	}
}

function serviceModule() {
	if ('ontouchstart' in document.documentElement) {
		$('.services_module__grid').addClass('touch_device');
	}
}

function sliderModule() {
	if ($('.slider_module__slider').length) {
		new Swiper('.slider_module__slider', {
			slidesPerView: 1,
			autoHeight: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			loop: true,
			spaceBetween: 24,
			direction: 'horizontal',
			pagination: {
				el: '.swiper-pagination',
				// dynamicBullets: true,
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			on: {
				// lazy load images
				slideChange() {
					try {
						// eslint-disable-next-line no-undef
						lazyLoadInstance.update();
					} catch (e) {}
				},
			},
		});
	}
}

function overviewModule() {
	if ($('.overview__slider').length) {
		new Swiper('.overview__slider', {
			slidesPerView: 1,
			autoHeight: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			loop: true,
			spaceBetween: 24,
			direction: 'horizontal',
			navigation: {
				nextEl: '.overview_module .swiper-button-next',
			},
			on: {
				// lazy load images
				slideChange() {
					try {
						// eslint-disable-next-line no-undef
						lazyLoadInstance.update();
					} catch (e) {}
				},
			},
		});
	}
}
